import { useGetEntities } from '@abaninja/util-store';

import { getOrganizations } from '../organizations';

export const useOrganizationsStore = () => useGetEntities(getOrganizations);
